<template>
<div class="container">
  <ul class="tab">
    <li class="tab-item" @click.prevent="tab = 1" :class="{active: tab === 1}">
      <a href="#">New Invoice</a>
    </li>
    <li class="tab-item" @click.prevent="tab = 2" :class="{active: tab === 2}">
      <a href="#">Invoices</a>
    </li>
    <li class="tab-item" @click.prevent="tab = 3" :class="{active: tab === 3}">
      <a href="#">Overdue</a>
    </li>
  </ul>

  <makeinvoice v-if="tab === 1" :invoices="invoices_all" v-on:new="getInvoices"></makeinvoice>
  <invoiceList v-if="tab === 2" :invoices="invoices_all" :showOverdue="false" v-on:del="getInvoices"></invoiceList>
  <invoiceList v-if="tab === 3" :invoices="invoices_overdue" :showOverdue="true" v-on:del="getInvoices"></invoiceList>

</div>
</template>

<script>
import axios from 'axios'
import adminInvoices from '@/components/accounts/adminInvoices'
import makeInvoice from '@/components/accounts/makeInvoice'
import pay from '@/components/accounts/pay'

export default {
  name: 'agreements',
  components: {
    'invoiceList': adminInvoices,
    'makeinvoice': makeInvoice,
    'pay': pay
  },
  data () {
    return {
      tab: 1,
      invoices_all: [],
      invoices_overdue: []
    }
  },
  created: function () {
    this.$root.$data.pageTitle = 'Accounts'
    this.getInvoices()
  },
  methods: {
    getInvoices: function () {
      axios.get('/api/invoices/all').then(res => {
        if (res.status === 200) {
          if (res.data) this.invoices_all = res.data
        }
      })
      axios.get('/api/invoices/overdue').then(res => {
        if (res.status === 200) {
          if (res.data) this.invoices_overdue = res.data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// accounts.vue?95407c12